(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* —— Infinite carousels: loop + horizontal-only interaction —— */
  var HORIZONTAL_TRACKS = [
    '.pf-ingredient-row[data-ingredient-carousel]',
    '.pf-results .pf-review-row',
    '.pf-results .pf-video-row',
    '.pf-claims-row'
  ].join(', ');

  var INFINITE_TRACKS = [
    '.pf-ingredient-row[data-ingredient-carousel]',
    '.pf-results .pf-review-row',
    '.pf-results .pf-video-row',
    '.pf-claims-row'
  ].join(', ');

  function attachCarouselAutoplay(container, advance, delay) {
    if (prefersReduced || !container || typeof advance !== 'function') return;

    var timer = null;
    var inView = false;
    var paused = false;
    var resumeTimer = null;

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (paused || !inView || document.hidden) return;
      timer = window.setInterval(function () {
        if (!paused && inView && !document.hidden) advance();
      }, Math.max(4000, Number(delay) || 6500));
    }

    function pause() {
      paused = true;
      window.clearTimeout(resumeTimer);
      stop();
    }

    function resumeSoon() {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        paused = false;
        start();
      }, 1800);
    }

    container.addEventListener('mouseenter', pause);
    container.addEventListener('mouseleave', function () {
      paused = false;
      start();
    });
    container.addEventListener('focusin', pause);
    container.addEventListener('focusout', function (event) {
      if (container.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });
    container.addEventListener('pointerdown', pause, { passive: true });
    window.addEventListener('pointerup', resumeSoon, { passive: true });
    container.addEventListener('touchend', resumeSoon, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        inView = entries[0] && entries[0].isIntersecting;
        if (inView) start();
        else stop();
      }, { threshold: 0.25 });
      observer.observe(container);
    } else {
      inView = true;
      start();
    }
  }

  function stripRevealInside(track) {
    track.querySelectorAll('.pf-reveal').forEach(function (el) {
      el.classList.remove('pf-reveal', 'pf-reveal--left', 'pf-reveal--right', 'pf-reveal--scale');
      el.classList.add('is-in');
    });
  }

  function applyHorizontalInteraction(track) {
    if (track.dataset.pfHorizontalReady === '1') return;
    track.dataset.pfHorizontalReady = '1';
    track.classList.add('pf-horizontal-track');
    stripRevealInside(track);

    track.addEventListener('wheel', function (event) {
      var absX = Math.abs(event.deltaX);
      var absY = Math.abs(event.deltaY);

      if (event.shiftKey) {
        event.preventDefault();
        track.scrollLeft += event.deltaY || event.deltaX;
        return;
      }

      /* Vertical (or mostly vertical) always moves the PAGE, never the card row. */
      if (absY >= absX) {
        event.preventDefault();
        window.scrollBy(0, event.deltaY);
        return;
      }

      event.preventDefault();
      track.scrollLeft += event.deltaX;
    }, { passive: false });

    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    track.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      if (event.target.closest('button, a, video, iframe, input, textarea, select')) return;
      dragging = true;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    function endDrag() {
      dragging = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      event.preventDefault();
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var touchAxis = null;

    track.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchAxis = null;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (event.touches.length !== 1) return;
      var dx = event.touches[0].clientX - touchStartX;
      var dy = event.touches[0].clientY - touchStartY;
      if (!touchAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        touchAxis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
      }
      /* Vertical swipes are page scroll — never trap them. */
    }, { passive: true });

    track.addEventListener('touchend', function () {
      touchAxis = null;
    }, { passive: true });
  }

  function initInfiniteLoop(track) {
    var originals = Array.from(track.children).filter(function (el) {
      return !el.hasAttribute('data-pf-clone');
    });
    if (!originals.length) return;

    originals.forEach(function (item) {
      item.setAttribute('data-pf-original', '1');
    });

    originals.slice().reverse().forEach(function (item) {
      var before = item.cloneNode(true);
      before.setAttribute('data-pf-clone', '1');
      before.setAttribute('aria-hidden', 'true');
      track.insertBefore(before, track.firstChild);
    });

    originals.forEach(function (item) {
      var after = item.cloneNode(true);
      after.setAttribute('data-pf-clone', '1');
      after.setAttribute('aria-hidden', 'true');
      track.appendChild(after);
    });

    var setWidth = 0;
    var jumping = false;

    function measureSetWidth() {
      if (!originals.length) return 0;
      var first = originals[0];
      var last = originals[originals.length - 1];
      return last.offsetLeft + last.offsetWidth - first.offsetLeft;
    }

    function syncLoop() {
      if (!setWidth || jumping) return;
      if (track.scrollLeft >= setWidth * 2 - 2) {
        jumping = true;
        track.scrollLeft -= setWidth;
        jumping = false;
      } else if (track.scrollLeft <= 2) {
        jumping = true;
        track.scrollLeft += setWidth;
        jumping = false;
      }
    }

    function layoutStart() {
      setWidth = measureSetWidth();
      if (setWidth > 0) track.scrollLeft = setWidth;
    }

    layoutStart();
    requestAnimationFrame(function () {
      layoutStart();
      stripRevealInside(track);
    });

    track.addEventListener('scroll', syncLoop, { passive: true });

    window.addEventListener('resize', function () {
      var prev = setWidth || 1;
      var ratio = track.scrollLeft / prev;
      setWidth = measureSetWidth();
      if (setWidth > 0) track.scrollLeft = setWidth * Math.max(1, Math.min(2, ratio || 1));
    });
  }

  function initCarousels() {
    document.querySelectorAll(HORIZONTAL_TRACKS).forEach(applyHorizontalInteraction);
    document.querySelectorAll(INFINITE_TRACKS).forEach(function (track) {
      initInfiniteLoop(track);
      var delay = track.matches('.pf-video-row') ? 6500 : track.matches('.pf-review-row') ? 5600 : 4800;
      attachCarouselAutoplay(track, function () {
        if (track.querySelector('.is-playing')) return;
        var card = track.querySelector('[data-pf-original]') || track.querySelector('article');
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.75;
        track.scrollBy({ left: distance, behavior: 'smooth' });
      }, delay);
    });
  }

  var SLIDER_SECTIONS = ['pf-results', 'pf-ingredients', 'pf-symptoms', 'pf-decline', 'pf-pathways', 'pf-promise', 'pf-claims'];

  /* —— Scroll reveal —— */
  function initReveals() {
    const targets = [];
    document.querySelectorAll('.pf section, .pf-proof-strip, .pf-footer').forEach(function (section) {
      if (section.classList.contains('pf-hero')) return;
      if (SLIDER_SECTIONS.some(function (cls) { return section.classList.contains(cls); })) {
        section.classList.add('pf-reveal-fade');
      } else {
        section.classList.add('pf-reveal');
      }
      targets.push(section);

      const staggerParents = section.querySelectorAll(
        '.pf-price-grid, .pf-quality__grid, .pf-press__grid, .pf-proof-strip .pf-shell, .pf-tested__stats'
      );
      staggerParents.forEach(function (parent) {
        parent.classList.add('pf-reveal-stagger');
        Array.from(parent.children).forEach(function (child) {
          child.classList.add('pf-reveal');
          targets.push(child);
        });
      });
    });

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      document.documentElement.classList.add('js-ready');
      return;
    }

    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
      }
    });

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) { io.observe(el); });
    document.documentElement.classList.add('js-ready');
  }

  /* —— Transparency modals —— */
  function initModals() {
    let lastOpener = null;
    const openers = document.querySelectorAll('[data-pf-open-modal]');
    openers.forEach(function (opener) {
      opener.addEventListener('click', function (event) {
        const id = opener.getAttribute('data-pf-open-modal');
        const dialog = id ? document.getElementById(id) : null;
        if (!dialog) return;
        event.preventDefault();
        lastOpener = opener;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        if (id === 'pf-modal-coa' && typeof dialog.pfGoToCoa === 'function') {
          dialog.pfGoToCoa(0, true);
        }
        const panel = dialog.querySelector('.pf-modal__panel');
        if (panel) {
          panel.focus({ preventScroll: true });
        }
      });
    });

    document.querySelectorAll('.pf-modal').forEach(function (dialog) {
      dialog.querySelectorAll('[data-pf-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (![...document.querySelectorAll('.pf-modal')].some(function (d) { return d.open; })) {
          document.documentElement.style.overflow = '';
        }
        if (lastOpener && typeof lastOpener.focus === 'function') {
          lastOpener.focus({ preventScroll: true });
        }
      });
    });

    initCoaViewer();
  }

  function initCoaViewer() {
    const dialog = document.getElementById('pf-modal-coa');
    const viewer = document.querySelector('[data-pf-coa-viewer]');
    const track = document.querySelector('[data-pf-coa-track]');
    const current = document.querySelector('[data-pf-coa-current]');
    const status = document.querySelector('[data-pf-coa-status]');
    const prev = document.querySelector('[data-pf-coa-prev]');
    const next = document.querySelector('[data-pf-coa-next]');
    if (!track) return;

    const slides = Array.prototype.slice.call(track.querySelectorAll('[data-pf-coa-slide], .pf-coa-slide'));
    if (!slides.length) return;
    let index = 0;
    let ticking = false;

    function clamp(value) {
      return Math.max(0, Math.min(value, slides.length - 1));
    }

    function updateUi() {
      if (current) current.textContent = String(index + 1);
      const name = slides[index] && slides[index].querySelector('.pf-coa-slide__name');
      if (status) {
        status.textContent = 'Showing certificate ' + (index + 1) + ' of ' + slides.length + (name ? ': ' + name.textContent.trim() : '');
      }
      if (prev) {
        prev.disabled = index === 0;
        prev.setAttribute('aria-disabled', String(index === 0));
      }
      if (next) {
        next.disabled = index === slides.length - 1;
        next.setAttribute('aria-disabled', String(index === slides.length - 1));
      }
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    }

    function goTo(nextIndex, instant) {
      index = clamp(nextIndex);
      const width = track.clientWidth || 1;
      const behavior = instant || prefersReduced ? 'auto' : 'smooth';
      track.scrollTo({ left: width * index, behavior: behavior });
      const body = dialog && dialog.querySelector('.pf-coa-body');
      if (body) body.scrollTop = 0;
      updateUi();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        const width = track.clientWidth || 1;
        index = clamp(Math.round(track.scrollLeft / width));
        updateUi();
        ticking = false;
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { goTo(index, true); });

    if (dialog) {
      dialog.addEventListener('keydown', function (event) {
        if (!dialog.open) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          goTo(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          goTo(slides.length - 1);
        }
      });
      dialog.pfGoToCoa = goTo;
    }

    updateUi();
  }

  /* —— Mobile persistent purchase CTA —— */
  function initMobileBuyBar() {
    const bar = document.querySelector('[data-pf-mobile-buy]');
    const hero = document.querySelector('.pf-hero');
    const pricing = document.querySelector('#pf-product');
    const finalCta = document.querySelector('.pf-final');
    const footer = document.querySelector('.pf-footer');
    const mobile = window.matchMedia('(max-width: 900px)');
    if (!bar || !hero) return;

    let heroVisible = true;
    let pricingVisible = false;
    let finalVisible = false;
    let footerVisible = false;

    function showGoToCart() {
      const cta = bar.querySelector('.pf-mobile-buy__cta');
      const title = bar.querySelector('.pf-mobile-buy__proof strong');
      const note = bar.querySelector('.pf-mobile-buy__proof small');
      if (cta) {
        cta.setAttribute('href', bar.dataset.cartUrl || '/cart');
        cta.innerHTML = 'Go to cart <span aria-hidden="true">→</span>';
      }
      if (title) title.textContent = 'Added to your cart';
      if (note) note.textContent = 'Finish checkout anytime';
      bar.classList.add('is-cart');
      update();
    }

    document.addEventListener('pf:added-to-cart', showGoToCart);

    function update() {
      const visible = mobile.matches && (bar.classList.contains('is-cart') || (!heroVisible && !pricingVisible && !finalVisible && !footerVisible));
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      document.body.classList.toggle('pf-mobile-buy-visible', visible);
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          if (entry.target === pricing) pricingVisible = entry.isIntersecting;
          if (entry.target === finalCta) finalVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        update();
      }, { threshold: 0.08 });
      [hero, pricing, finalCta, footer].filter(Boolean).forEach(function (element) {
        observer.observe(element);
      });
    } else {
      const check = function () {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const pricingBox = pricing && pricing.getBoundingClientRect();
        const finalBox = finalCta && finalCta.getBoundingClientRect();
        const footerBox = footer && footer.getBoundingClientRect();
        heroVisible = heroBottom > 0;
        pricingVisible = !!pricingBox && pricingBox.top < window.innerHeight && pricingBox.bottom > 0;
        finalVisible = !!finalBox && finalBox.top < window.innerHeight && finalBox.bottom > 0;
        footerVisible = !!footerBox && footerBox.top < window.innerHeight && footerBox.bottom > 0;
        update();
      };
      window.addEventListener('scroll', check, { passive: true });
      check();
    }

    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', update);
    }
    update();
  }

  function initDeclineCarousels() {
    document.querySelectorAll('[data-pf-decline-carousel]').forEach(function (section) {
      if (section.dataset.pfDeclineReady === '1') return;
      section.dataset.pfDeclineReady = '1';

      var track = section.querySelector('[data-pf-decline-track]');
      var slides = Array.from(section.querySelectorAll('[data-pf-decline-slide]'));
      var dots = Array.from(section.querySelectorAll('[data-pf-decline-dot]'));
      if (!track || slides.length < 2) return;

      var index = 0;
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var locked = null;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if ('inert' in slide) slide.inert = !active;
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      section.querySelectorAll('[data-pf-decline-next]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index + 1);
        });
      });
      section.querySelectorAll('[data-pf-decline-prev]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index - 1);
        });
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(Number(dot.getAttribute('data-pf-decline-dot')) || 0);
        });
      });

      function pointerDown(event) {
        if (event.target.closest('button, a, input, textarea, select')) return;
        dragging = true;
        locked = null;
        startX = event.clientX || (event.touches && event.touches[0].clientX) || 0;
        startY = event.clientY || (event.touches && event.touches[0].clientY) || 0;
      }

      function pointerMove(event) {
        if (!dragging) return;
        var x = event.clientX || (event.touches && event.touches[0].clientX) || 0;
        var y = event.clientY || (event.touches && event.touches[0].clientY) || 0;
        var dx = x - startX;
        var dy = y - startY;
        if (!locked) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          locked = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
        }
        if (locked === 'x' && event.cancelable) event.preventDefault();
      }

      function pointerUp(event) {
        if (!dragging) return;
        dragging = false;
        if (locked !== 'x') {
          locked = null;
          return;
        }
        var x = event.changedTouches ? event.changedTouches[0].clientX : event.clientX;
        var dx = x - startX;
        if (dx < -48) goTo(index + 1);
        else if (dx > 48) goTo(index - 1);
        locked = null;
      }

      var viewport = section.querySelector('.pf-decline-viewport') || track;
      viewport.addEventListener('mousedown', pointerDown);
      window.addEventListener('mousemove', pointerMove);
      window.addEventListener('mouseup', pointerUp);
      viewport.addEventListener('touchstart', pointerDown, { passive: true });
      viewport.addEventListener('touchmove', pointerMove, { passive: false });
      viewport.addEventListener('touchend', pointerUp, { passive: true });

      var carousel = section.querySelector('.pf-decline-carousel') || section;
      carousel.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      });

      goTo(0);
      attachCarouselAutoplay(section, function () {
        goTo(index + 1);
      }, Number(section.dataset.pfAutoplay) || 7000);
    });
  }

  function initFeatureCarousels() {
    document.querySelectorAll('[data-pf-feature-carousel]').forEach(function (section) {
      if (section.dataset.pfFeatureReady === '1') return;
      section.dataset.pfFeatureReady = '1';

      var track = section.querySelector('[data-pf-feature-track]');
      var slides = Array.from(section.querySelectorAll('[data-pf-feature-slide]'));
      var dots = Array.from(section.querySelectorAll('[data-pf-feature-dot]'));
      var prev = section.querySelector('[data-pf-feature-prev]');
      var next = section.querySelector('[data-pf-feature-next]');
      var viewport = section.querySelector('.pf-feature-viewport');
      if (!track || slides.length < 2) return;

      var index = 0;
      var startX = 0;
      var startY = 0;
      var axis = null;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if ('inert' in slide) slide.inert = !active;
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(Number(dot.dataset.pfFeatureDot) || 0);
        });
      });

      if (viewport) {
        viewport.addEventListener('touchstart', function (event) {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          axis = null;
        }, { passive: true });
        viewport.addEventListener('touchmove', function (event) {
          if (event.touches.length !== 1) return;
          var dx = event.touches[0].clientX - startX;
          var dy = event.touches[0].clientY - startY;
          if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
            axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          }
          if (axis === 'x' && event.cancelable) event.preventDefault();
        }, { passive: false });
        viewport.addEventListener('touchend', function (event) {
          if (axis !== 'x' || !event.changedTouches.length) return;
          var dx = event.changedTouches[0].clientX - startX;
          if (dx < -48) goTo(index + 1);
          else if (dx > 48) goTo(index - 1);
          axis = null;
        }, { passive: true });
      }

      section.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      });

      goTo(0);
      attachCarouselAutoplay(section, function () {
        goTo(index + 1);
      }, Number(section.dataset.pfAutoplay) || 7000);
    });
  }

  /* Build carousel clones before binding card controls so cloned videos work too. */
  initCarousels();
  initDeclineCarousels();
  initFeatureCarousels();

  const roots = document.querySelectorAll('.pf');
  if (!roots.length) {
    initReveals();
    initModals();
    initMobileBuyBar();
    return;
  }

  roots.forEach(function (root) {
    const menuButton = root.querySelector('.pf-menu-toggle');
    const mobileNav = root.querySelector('.pf-mobile-nav');
    if (menuButton && mobileNav) {
      menuButton.addEventListener('click', function () {
        const open = mobileNav.classList.toggle('is-open');
        menuButton.setAttribute('aria-expanded', String(open));
      });
      mobileNav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileNav.classList.remove('is-open');
          menuButton.setAttribute('aria-expanded', 'false');
        });
      });
    }

    const productDataNode = root.querySelector('[data-pf-product]');
    const productData = productDataNode ? JSON.parse(productDataNode.textContent) : null;
    const toast = root.querySelector('.pf-toast');
    let toastTimer;
    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
    }

    root.querySelectorAll('.pf-add').forEach(function (button) {
      if (!productData || !productData.available) {
        button.disabled = true;
        button.textContent = productData ? 'Sold out' : 'Select product in editor';
        return;
      }
      button.addEventListener('click', async function () {
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        try {
          const item = { id: productData.variantId, quantity: Number(button.dataset.quantity || 1) };
          const selectedMode = root.querySelector('input[name="pf-purchase-mode"]:checked');
          if (selectedMode && selectedMode.value === 'subscribe' && productData.sellingPlanId) item.selling_plan = productData.sellingPlanId;
          const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(shopRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (!response.ok) throw new Error('Unable to add this item.');
          button.textContent = 'Added ✓';
          showToast('Primali-T was added to your cart.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('pf:added-to-cart'));
          setTimeout(function () { button.textContent = original; button.disabled = false; }, 1800);
        } catch (error) {
          showToast(error.message || 'Something went wrong. Please try again.');
          button.textContent = original;
          button.disabled = false;
        }
      });
    });

    root.querySelectorAll('[data-pf-video-card]').forEach(function (card) {
      const play = card.querySelector('[data-pf-video-play]');
      const video = card.querySelector('video');
      const iframe = card.querySelector('iframe[data-pf-video-src]');
      if (!play || (!video && !iframe)) return;

      if (video) {
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
        });
      }

      play.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        document.querySelectorAll('[data-pf-video-card].is-playing').forEach(function (other) {
          if (other === card) return;
          const otherVideo = other.querySelector('video');
          const otherFrame = other.querySelector('iframe');
          if (otherVideo) {
            otherVideo.pause();
            otherVideo.currentTime = 0;
          }
          if (otherFrame) otherFrame.removeAttribute('src');
          other.classList.remove('is-playing');
        });

        card.classList.add('is-playing');
        if (video) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        }
        if (iframe && iframe.dataset.pfVideoSrc) iframe.src = iframe.dataset.pfVideoSrc;
      });
    });

    function bindTrackButtons(trackSelector, prevSelector, nextSelector) {
      const track = root.querySelector(trackSelector);
      const prev = root.querySelector(prevSelector);
      const next = root.querySelector(nextSelector);
      if (!track) return;
      function move(direction) {
        const card = track.querySelector('[data-pf-original]') || track.querySelector('article');
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.75;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    }
    bindTrackButtons('[data-ingredient-carousel]', '[data-ingredient-prev]', '[data-ingredient-next]');
    bindTrackButtons('.pf-video-row', '[data-results-video-prev]', '[data-results-video-next]');
    bindTrackButtons('.pf-review-row', '[data-results-review-prev]', '[data-results-review-next]');
    bindTrackButtons('.pf-claims-row', '[data-claims-prev]', '[data-claims-next]');
  });

  initReveals();
  initModals();
  initMobileBuyBar();
})();
